module.exports = __webpack_public_path__ + "static/img/simplifySalesPhone.52d88619.png";